<template>
  <HiDatatable
    :headers="headers"
    :items="leads"
    search-bar
    @select="selectRow"
    sort-by="dateUpdated"
    desc
    search-label-type="leads"
    style="height:100%"
    local-id="hive-leads-list"
  ></HiDatatable>
</template>

<script>
import HiDatatable from "@/components/HiDatatable";
import Formatter from "@/hive/Formatter";
import { db, docs, users } from "@/db";
import moment from "moment";

export default {
  name: "LeadsList",
  components: {
    HiDatatable
  },
  props: {
    projects: {
      type: [Array, String],
      required: true
    }
  },
  data() {
    return {
      selectedRow: null,
      headers: [
        {
          text: "Name",
          sortable: true,
          bold: true,
          capitalize: true,
          value: "name",
          badge: item => {
            return this.isNew(item);
          },
          renderer: item => {
            let text = item.name;
            if (item.surname) text += " " + item.surname;
            if (item.source) {
              text += `<div class="ui-text">${item.source}</div>`;
            }
            // if (this.isNew(item)) text += "(new)";
            return text;
          },
          width: "175px"
        },
        {
          text: "Phone",
          sortable: false,
          filterable: false,
          renderer: item => {
            /** @namespace item.phone **/
            return item.mobile || item.phone;
          },
          width: "150px",
          hidden: 1000
        },
        {
          text: "Update",
          value: "dateUpdated",
          sortable: true,
          filterable: false,
          renderer: item => {
            /** @namespace item.dateUpdated **/
            return Formatter.friendlyTimeShorter(item.dateUpdated);
          },
          width: "110px",
          dense: true
        },
        {
          text: "Created",
          value: "dateCreated",
          sortable: true,
          filterable: false,
          renderer: item => {
            /** @namespace item.dateCreated **/
            return Formatter.friendlyTimeShorter(item.dateCreated);
          },
          width: "110px",
          dense: true,
          hidden: 550
        },
        {
          text: "PostCode",
          value: "postcode",
          sortable: false,
          filterable: false,
          width: "60px",
          hidden: 900
        },
        {
          text: "SRC",
          value: "source",
          filterable: false,
          uppercase: true,
          classes: "ui-text",
          width: "95px",
          hidden: 720
        },
        {
          text: "Labels",
          value: "labels",
          filterable: false,
          uppercase: true,
          renderer: item => {
            let html = " ";
            if (item.labels) {
              item.labels.forEach(label => {
                // html += label;
                const style = this.labels[label];
                if (style) {
                  html += `<span style="color:${style[0]};background-color:${style[1]}" class="label">${label}</span>`;
                } else {
                  html += `<span class="label">${label}</span>`;
                }
              });
            }
            return html;
          },
          hidden: 650
        }
      ],
      itemsPerPage: 25,
      leads: [],
      labels: {},
      recentComments: []
    };
  },
  firestore: {
    // leads: db.collection("leads").where('projects', 'array-contains-any'),
    labels: docs.labels.leads
    // recentComments: collections.leadComments
    //   .where("user", "!=", users.currentUserUid())
    //   //(new Date() - 86400000 * 14) / 1000)
    //   // .where(
    //   //   "dateCreated",
    //   //   ">",
    //   //   moment()
    //   //     .add(-14, "d")
    //   //     .milliseconds()
    //   // )
    //   .orderBy("user")
    //   .orderBy("dateCreated", "desc")
    //   .limit(100)
  },
  methods: {
    selectRow(item) {
      this.$emit("select", item);
    },
    isNew(item) {
      // console.log(item.id);
      const start = moment("20201026", "YYYYMMDD");
      const now = moment();
      const dateUpdated = item.dateUpdated;
      if (!dateUpdated) return false;
      const momentUpdated = moment.unix(dateUpdated.seconds);
      if (momentUpdated.isBefore(start)) return false;
      //7 days ago isn't new
      if (now.diff(momentUpdated, "days") > 7) return false;
      const userVisits = item.userVisits;
      if (userVisits) {
        // console.log("userVisits");
        const visitTime = userVisits[users.currentUserUid()];
        if (visitTime) {
          const momentVisited = moment.unix(visitTime.seconds);
          if (momentVisited.isAfter(momentUpdated)) {
            // console.log("isAfter");
            return false;
          }
        }
      }

      // console.log(item.name);
      // console.log(momentUpdated);
      return true;
    }
    // newComments(leadId) {
    //   const comments = this.recentCommentsByLeads["leads/" + leadId];
    //   console.log(comments);
    // }
  },
  watch: {
    projects: {
      immediate: true,
      handler(val) {
        // console.log(val);
        if (val === "all") {
          this.$bind("leads", db.collection("leads"));
        } else {
          this.$bind(
            "leads",
            db.collection("leads").where("projects", "array-contains-any", val)
          );
        }
      }
    }
  },
  computed: {
    // recentCommentsByLeads() {
    //   const obj = {};
    //   for (let i = 0; i < this.recentComments.length; i++) {
    //     const comment = this.recentComments[i];
    //     const location = comment.location;
    //     console.log(location);
    //     if (!obj[location]) obj[location] = [];
    //     obj[location].push(comment);
    //   }
    //   console.log(obj);
    //   return obj;
    // }
  }
};
</script>

<style scoped></style>
